import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Header } from '../../../components/shared/header/header';
import { Sidebar } from '../../../components/shared/sidebar/sidebar';
import { PickListService } from '../../shared/services/picklist.service';
import { NotificationSocketService } from '../../shared/services/notification-socket.service';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [Sidebar, Header, RouterOutlet, CommonModule],
  templateUrl: './main-layout.html',
})
export class MainLayout {
  constructor(
    private pickListService: PickListService,
    public notificationSocket: NotificationSocketService,  // public — template access
  ) {
    this.pickListService.loadGlobalLists();
  }
}